import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { FaTrashAlt, FaEdit, FaPlus, FaCheck, FaTimes, FaGlobe } from 'react-icons/fa';
import Swal from 'sweetalert2';
import PaisForm from './PaisForm';

// eslint-disable-next-line no-unused-vars
const getFlagUrl = (flagCode) => {
  return `/flags/${flagCode}.png`;
};

// eslint-disable-next-line no-unused-vars
const countryToFlag = {
  // Europa
  'France': 'fr', 'França': 'fr',
  'Germany': 'de', 'Alemanha': 'de',
  'United Kingdom': 'gb', 'Reino Unido': 'gb',
  'Netherlands': 'nl', 'Holanda': 'nl', 'Países Baixos': 'nl',
  'Belgium': 'be', 'Bélgica': 'be',
  'Switzerland': 'ch', 'Suíça': 'ch',
  'Austria': 'at', 'Áustria': 'at',
  'Sweden': 'se', 'Suécia': 'se',
  'Norway': 'no', 'Noruega': 'no',
  'Denmark': 'dk', 'Dinamarca': 'dk',
  'Finland': 'fi', 'Finlândia': 'fi',
  'Poland': 'pl', 'Polônia': 'pl',
  'Czech Republic': 'cz', 'República Tcheca': 'cz',
  'Hungary': 'hu', 'Hungria': 'hu',
  'Romania': 'ro', 'Romênia': 'ro',
  'Bulgaria': 'bg', 'Bulgária': 'bg',
  'Croatia': 'hr', 'Croácia': 'hr',
  'Slovakia': 'sk', 'Eslováquia': 'sk',
  'Lithuania': 'lt', 'Lituânia': 'lt',
  'Latvia': 'lv', 'Letônia': 'lv',
  'Estonia': 'ee', 'Estônia': 'ee',
  'Malta': 'mt',
  'Luxembourg': 'lu', 'Luxemburgo': 'lu',
  'Italy': 'it', 'Itália': 'it',
  'Spain': 'es', 'Espanha': 'es',
  'Portugal': 'pt',
  'Greece': 'gr', 'Grécia': 'gr',
  'Ireland': 'ie', 'Irlanda': 'ie',
  'Iceland': 'is', 'Islândia': 'is',
  'Slovenia': 'si', 'Eslovênia': 'si',
  'Serbia': 'rs', 'Sérvia': 'rs',
  'Montenegro': 'me',
  'Bosnia and Herzegovina': 'ba', 'Bósnia e Herzegovina': 'ba',
  'North Macedonia': 'mk', 'Macedônia do Norte': 'mk',
  'Albania': 'al', 'Albânia': 'al',
  'Moldova': 'md',
  'Ukraine': 'ua', 'Ucrânia': 'ua',
  'Belarus': 'by', 'Bielorrússia': 'by',
  'Russia': 'ru', 'Rússia': 'ru',
  
  // América do Norte
  'United States': 'us', 'Estados Unidos': 'us',
  'Canada': 'ca', 'Canadá': 'ca',
  'Mexico': 'mx', 'México': 'mx',
  
  // América do Sul
  'Brazil': 'br', 'Brasil': 'br',
  'Argentina': 'ar',
  'Chile': 'cl',
  'Colombia': 'co', 'Colômbia': 'co',
  'Peru': 'pe',
  'Venezuela': 've',
  'Uruguay': 'uy',
  'Paraguay': 'py',
  'Bolivia': 'bo', 'Bolívia': 'bo',
  'Ecuador': 'ec',
  'Guyana': 'gy',
  'Suriname': 'sr',
  
  // Ásia
  'Japan': 'jp', 'Japão': 'jp',
  'China': 'cn',
  'India': 'in', 'Índia': 'in',
  'South Korea': 'kr', 'Coreia do Sul': 'kr',
  'Thailand': 'th', 'Tailândia': 'th',
  'Vietnam': 'vn', 'Vietnã': 'vn',
  'Malaysia': 'my', 'Malásia': 'my',
  'Indonesia': 'id', 'Indonésia': 'id',
  'Philippines': 'ph', 'Filipinas': 'ph',
  'Singapore': 'sg', 'Singapura': 'sg',
  'Taiwan': 'tw',
  'Hong Kong': 'hk',
  'Macau': 'mo',
  
  // Oriente Médio
  'Israel': 'il',
  'Turkey': 'tr', 'Turquia': 'tr',
  'Saudi Arabia': 'sa', 'Arábia Saudita': 'sa',
  'UAE': 'ae', 'Emirados Árabes Unidos': 'ae',
  'Qatar': 'qa',
  'Kuwait': 'kw',
  'Bahrain': 'bh',
  'Oman': 'om',
  'Jordan': 'jo', 'Jordânia': 'jo',
  'Lebanon': 'lb', 'Líbano': 'lb',
  'Iran': 'ir', 'Irã': 'ir',
  'Iraq': 'iq', 'Iraque': 'iq',
  
  // Oceania
  'Australia': 'au', 'Austrália': 'au',
  'New Zealand': 'nz', 'Nova Zelândia': 'nz',
  
  // África
  'South Africa': 'za', 'África do Sul': 'za',
  'Egypt': 'eg', 'Egito': 'eg',
  'Morocco': 'ma', 'Marrocos': 'ma',
  'Nigeria': 'ng', 'Nigéria': 'ng',
  'Kenya': 'ke', 'Quênia': 'ke',
  'Ghana': 'gh',
  'Tunisia': 'tn', 'Tunísia': 'tn',
  'Algeria': 'dz', 'Argélia': 'dz',
  'Ethiopia': 'et', 'Etiópia': 'et',
  'Uganda': 'ug',
  'Tanzania': 'tz', 'Tanzânia': 'tz',
  'Mozambique': 'mz', 'Moçambique': 'mz',
  'Angola': 'ao',
  'Cameroon': 'cm', 'Camarões': 'cm',
  'Senegal': 'sn',
  'Mali': 'ml',
  'Niger': 'ne',
  'Guinea': 'gn', 'Guiné': 'gn',
  'Guinea-Bissau': 'gw', 'Guiné-Bissau': 'gw',
  'Equatorial Guinea': 'gq', 'Guiné Equatorial': 'gq',
  'Central African Republic': 'cf', 'República Centro-Africana': 'cf',
  'Madagascar': 'mg',
  'Mauritius': 'mu', 'Maurício': 'mu',
  'Botswana': 'bw',
  
  // Caribe e América Central
  'Jamaica': 'jm',
  'Barbados': 'bb',
  'Trinidad and Tobago': 'tt', 'Trinidad e Tobago': 'tt',
  'Bahamas': 'bs',
  'Dominican Republic': 'do', 'República Dominicana': 'do',
  'Puerto Rico': 'pr', 'Porto Rico': 'pr',
  'Costa Rica': 'cr',
  'Panama': 'pa', 'Panamá': 'pa',
  'Guatemala': 'gt',
  'Honduras': 'hn',
  'El Salvador': 'sv',
  'Nicaragua': 'ni',
  'Belize': 'bz',
  'Cuba': 'cu',
  'Haiti': 'ht',
  'Grenada': 'gd',
  'Saint Lucia': 'lc', 'Santa Lúcia': 'lc',
  'Saint Vincent and the Grenadines': 'vc', 'São Vicente e Granadinas': 'vc',
  'Antigua and Barbuda': 'ag', 'Antígua e Barbuda': 'ag',
  'Saint Kitts and Nevis': 'kn', 'São Cristóvão e Névis': 'kn',
  'Dominica': 'dm',
  'Anguilla': 'ai',
  'British Virgin Islands': 'vg', 'Ilhas Virgens Britânicas': 'vg',
  'Cayman Islands': 'ky', 'Ilhas Cayman': 'ky',
  'Turks and Caicos Islands': 'tc', 'Ilhas Turks e Caicos': 'tc',
  'Bermuda': 'bm',
};

const PageContainer = styled.div`
  padding: 40px;
  min-height: 100vh;
`;

const TableWrapper = styled.div`
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  overflow-x: auto;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  min-width: 500px;

  th, td {
    padding: 16px 12px;
    text-align: left;
    font-size: 0.95rem;
    border-bottom: 1px solid #eee;
  }

  th {
    background: #f8f9fa;
    color: #666;
    font-weight: 600;
    text-transform: uppercase;
  }

  tr:hover {
    background: #f8f9fa;
  }
`;

const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`;

const AddButton = styled.button`
  background: #34574A;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 1rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: background 0.2s;
  &:hover {
    background: #27443a;
  }
`;

const StatusButton = styled.button`
  background: ${props => props.$ativo ? '#22c55e' : '#c62828'};
  color: #fff;
  border: none;
  border-radius: 12px;
  font-size: 0.85rem;
  font-weight: 500;
  padding: 4px 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: background 0.2s;
  &:hover {
    opacity: 0.8;
  }
`;

const ActionCell = styled.td`
  display: flex;
  gap: 10px;
  align-items: center;
`;

const IconButton = styled.button`
  background: none;
  border: none;
  padding: 6px;
  border-radius: 6px;
  cursor: pointer;
  color: #c0843d;
  font-size: 1.1rem;
  transition: background 0.2s;
  &:hover {
    background: #f8f8f8;
    color: #c62828;
  }
`;

const Paises = () => {
  const [modalBandeira, setModalBandeira] = useState(null);
  const [paises, setPaises] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [editData, setEditData] = useState(null);
  const [pagina, setPagina] = useState(1);
  const paisesPorPagina = 6;
  const totalPaginas = Math.ceil(paises.length / paisesPorPagina);
  const paisesPaginados = paises.slice((pagina - 1) * paisesPorPagina, pagina * paisesPorPagina);

  const fetchPaises = () => {
    const token = localStorage.getItem('auth_token');
    if (!token) {
      setError('Token não encontrado.');
      setLoading(false);
      return;
    }
    setLoading(true);
    fetch(`${import.meta.env.VITE_URL_API}/pais`, {
      headers: {
        'accept': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    })
      .then(res => res.json())
      .then(data => {
        setPaises(data);
        setLoading(false);
      })
      .catch(() => {
        setError('Erro ao buscar países.');
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchPaises();
  }, []);

  useEffect(() => {
    if (paises.length > 0) {
      const token = localStorage.getItem('auth_token');
      paises.forEach(async pais => {
        if (pais.ativoPAIS !== 1) {
          try {
            // Atualiza status via PUT em /api/paises/{id} com nome e ativo
            const form = new FormData();
            form.append('nomePAIS', pais.nomePAIS);
            form.append('ativoPAIS', 1);
            const response = await fetch(`${import.meta.env.VITE_URL_API}/pais/${pais.codigoPAIS}`, {
              method: 'PUT',
              headers: {
                'Authorization': `Bearer ${token}`
              },
              body: form
            });
            let data;
            try {
              data = await response.clone().json();
            } catch {
              data = await response.text();
            }
            console.error(`Resposta ativação país ${pais.codigoPAIS}:`, {status: response.status, data});
            if (!response.ok) {
              alert(`Erro ao ativar país ${pais.nomePAIS || pais.codigoPAIS}: Status ${response.status} - ${typeof data === 'string' ? data : (data?.message || 'Erro desconhecido')}`);
            } else {
              console.log(`País ${pais.codigoPAIS} ativado com sucesso.`, data);
            }
          } catch (err) {
            console.error(`Erro de rede ao ativar país ${pais.codigoPAIS}:`, err);
            alert(`Erro de rede ao ativar país ${pais.nomePAIS || pais.codigoPAIS}`);
          }
        }
      });
      setTimeout(fetchPaises, 1500);
    }
  }, [paises.length, paises]);

  const handleAdd = () => {
    setEditData(null);
    setShowForm(true);
  };

  const handleEdit = (pais) => {
    setEditData(pais);
    setShowForm(true);
  };

  const handleDelete = (pais) => {
    const token = localStorage.getItem('auth_token');
    if (!token) return;
    Swal.fire({
      title: 'Tem certeza?',
      text: `Deseja realmente excluir o país "${pais.nomePAIS}"? Esta ação não poderá ser desfeita!`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#c62828',
      cancelButtonColor: '#34574A',
      confirmButtonText: 'Sim, excluir',
      cancelButtonText: 'Cancelar',
      reverseButtons: true
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await fetch(`${import.meta.env.VITE_URL_API}/pais/${pais.codigoPAIS}`, {
            method: 'DELETE',
            headers: {
              'accept': 'application/json',
              'Authorization': `Bearer ${token}`
            }
          });
          Swal.fire('Excluído!', 'País excluído com sucesso.', 'success');
          fetchPaises();
        } catch {
          Swal.fire('Erro', 'Não foi possível excluir o país.', 'error');
        }
      }
    });
  };

  const handleFormSubmit = async (formData) => {
    const token = localStorage.getItem('auth_token');
    if (!token) return;
    const form = new FormData();
    form.append('nomePAIS', formData.nome);
    form.append('slugPAIS', formData.slug);
    form.append('ativoPAIS', formData.ativo);
    if (formData.foto) form.append('foto', formData.foto);
    try {
      if (editData) {
        await fetch(`${import.meta.env.VITE_URL_API}/pais/${editData.codigoPAIS}`, {
          method: 'PATCH',
          headers: {
            'Authorization': `Bearer ${token}`
          },
          body: form
        });
        Swal.fire('Sucesso', 'País atualizado com sucesso!', 'success');
      } else {
        await fetch(`${import.meta.env.VITE_URL_API}/pais`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`
          },
          body: form
        });
        Swal.fire('Sucesso', 'País criado com sucesso!', 'success');
      }
      setShowForm(false);
      fetchPaises();
    } catch {
      Swal.fire('Erro', 'Não foi possível salvar o país.', 'error');
    }
  };

  const handleFormCancel = () => {
    setShowForm(false);
    setEditData(null);
  };

  const handleToggleAtivo = async (pais) => {
    const novoStatus = pais.ativoPAIS === 1 ? 0 : 1;
    try {
      const token = localStorage.getItem('auth_token');
      const form = new FormData();
      form.append('ativoPAIS', novoStatus);
      form.append('codigoPAIS', pais.codigoPAIS);
      await fetch(`${import.meta.env.VITE_URL_API}/pais/${pais.codigoPAIS}`, {
        method: 'PATCH',
        headers: {
          'Authorization': `Bearer ${token}`
        },
        body: form
      });
      setTimeout(fetchPaises, 500);
    } catch {
      Swal.fire('Erro', 'Não foi possível atualizar o status.', 'error');
    }
  };

  return (
    <PageContainer>
      <HeaderRow>
        <h1>Países</h1>
        <AddButton onClick={handleAdd}>
          <FaPlus /> Novo País
        </AddButton>
      </HeaderRow>
      {showForm && (
        <div style={{position:'fixed',top:0,left:0,width:'100vw',height:'100vh',background:'rgba(0,0,0,0.25)',zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center'}}>
          <div style={{background:'#fff',padding:32,borderRadius:12,minWidth:360}}>
            <h2 style={{marginBottom:16}}>{editData ? 'Editar País' : 'Novo País'}</h2>
            <PaisForm onSubmit={handleFormSubmit} onCancel={handleFormCancel} initialData={editData} />
          </div>
        </div>
      )}
      {loading && <div>Carregando...</div>}
      {error && <div style={{color:'red'}}>{error}</div>}
      {!loading && !error && (
        <TableWrapper>
          <Table>
            <thead>
              <tr>
                <th>ID</th>
                <th>Nome</th>
                <th>Slug</th>
                <th>Bandeira</th>
                <th>Status</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {paisesPaginados.map(pais => (
                <tr key={pais.codigoPAIS}>
                  <td>{pais.codigoPAIS}</td>
                  <td>{pais.nomePAIS}</td>
                  <td>{pais.slugPAIS}</td>
                  <td>
                    <img
                      src={pais.fotoPAIS}
                      alt={pais.nomePAIS}
                      style={{
                        width: 32, height: 24, objectFit: 'cover',
                        borderRadius: 4, border: '1px solid #eee',
                        cursor: 'pointer'
                      }}
                      onClick={() => setModalBandeira({ url: pais.fotoPAIS, nome: pais.nomePAIS })}
                      onError={e => {
                        e.target.src = '/flags/br.png';
                        e.target.style.opacity = '0.5';
                      }}
                    />
                  </td>
                  <td>
                    <StatusButton
                      $ativo={pais.ativoPAIS === 1}
                      onClick={() => handleToggleAtivo(pais)}
                      title={pais.ativoPAIS === 1 ? 'Desativar' : 'Ativar'}
                    >
                      {pais.ativoPAIS === 1 ? <FaCheck /> : <FaTimes />} {pais.ativoPAIS === 1 ? 'Ativo' : 'Inativo'}
                    </StatusButton>
                  </td>
                  <ActionCell>
                    <IconButton onClick={() => handleEdit(pais)} title="Editar">
                      <FaEdit />
                    </IconButton>
                    <IconButton onClick={() => handleDelete(pais)} title="Excluir">
                      <FaTrashAlt />
                    </IconButton>
                  </ActionCell>
                </tr>
              ))}
            </tbody>
          </Table>
          {/* Paginação */}
          <div style={{display:'flex',justifyContent:'center',alignItems:'center',gap:8,margin:'24px 0'}}>
            <button onClick={()=>setPagina(p=>Math.max(1,p-1))} disabled={pagina===1} style={{padding:'6px 14px',borderRadius:6,border:'1px solid #eee',background:'#fff',cursor:pagina===1?'not-allowed':'pointer'}}>Anterior</button>
            {[...Array(totalPaginas)].map((_,i)=>(
              <button
                key={i}
                onClick={()=>setPagina(i+1)}
                style={{padding:'6px 12px',borderRadius:6,border:'1.5px solid '+(pagina===i+1?'#34574A':'#eee'),background:pagina===i+1?'#34574A':'#fff',color:pagina===i+1?'#fff':'#222',fontWeight:600,cursor:'pointer'}}
              >{i+1}</button>
            ))}
            <button onClick={()=>setPagina(p=>Math.min(totalPaginas,p+1))} disabled={pagina===totalPaginas} style={{padding:'6px 14px',borderRadius:6,border:'1px solid #eee',background:'#fff',cursor:pagina===totalPaginas?'not-allowed':'pointer'}}>Próxima</button>
          </div>
        </TableWrapper>
      )}
    {/* Modal de Bandeira Ampliada */}
    {modalBandeira && (
      <div
        style={{
          position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
          background: 'rgba(0,0,0,0.7)', zIndex: 2000, display: 'flex', alignItems: 'center', justifyContent: 'center'
        }}
        onClick={() => setModalBandeira(null)}
      >
        <div
          style={{ position: 'relative', background: '#fff', borderRadius: 12, padding: 24, boxShadow: '0 2px 16px rgba(0,0,0,0.3)' }}
          onClick={e => e.stopPropagation()}
        >
          <button
            onClick={() => setModalBandeira(null)}
            style={{ position: 'absolute', top: 10, right: 10, background: 'transparent', border: 'none', fontSize: 28, color: '#888', cursor: 'pointer' }}
            title="Fechar"
          >
            ×
          </button>
          <img
            src={modalBandeira.url}
            alt={modalBandeira.nome}
            style={{ maxWidth: '80vw', maxHeight: '70vh', display: 'block', margin: '0 auto', borderRadius: 8, border: '2px solid #eee', boxShadow: '0 2px 12px rgba(0,0,0,0.2)' }}
            onError={e => {
              e.target.src = '/flags/br.png';
              e.target.style.opacity = '0.5';
            }}
          />
          <div style={{marginTop:12, textAlign:'center', fontWeight:600, fontSize:18}}>{modalBandeira.nome}</div>
        </div>
      </div>
    )}
  </PageContainer>
  );
};

export default Paises;
